import React from 'react'
import PropTypes from 'prop-types'
import { routePaths } from '../../urls'
import { fetchLmsCourses, postLmsSettings } from '../../actions'
import ChooseForm from './ChooseForm'

export default class CanvasChoose extends React.Component {
  static contextTypes = {
    store: PropTypes.object,
    router: PropTypes.object,
  }

  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
    let { coursenum } = this.context.store.getState()
    this.context.store.dispatch(fetchLmsCourses(coursenum))
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  updateCanvasCourseId = courseId => {
    let { store } = this.context
    let { coursenum } = store.getState()
    store.dispatch(postLmsSettings(coursenum, { canvasCoursenum: courseId }))
    this.context.router.history.push(routePaths.canvasCreateTool)
  }

  render() {
    let { courseList, canvasCoursenum, courseTitle, selectErrorMsg } =
      this.context.store.getState()

    return (
      <div className="card-myed">
        <div className="canvas-flex-wrapper">
          <div className="canvas-form-container">
            <h3>3. Choose Course</h3>
            <p>
              The list below contains Canvas course titles to which you have
              access.
            </p>
            <p>
              Please select the Canvas course that you would like to link to
              your MyEducator Smart Textbook:{' '}
              <span className="bold">{courseTitle}</span>.
            </p>
            <ChooseForm
              onSubmit={this.updateCanvasCourseId}
              courses={courseList}
              courseId={canvasCoursenum}
              formErrorMsg={selectErrorMsg}
            />
          </div>
          <div className="canvas-statusmarker-container">
            <img src="/static/instructor/media/canvas-logo-lms.png" />
          </div>
        </div>
      </div>
    )
  }
}
